module.exports = __webpack_public_path__ + "static/media/NN Logo Final-01.c91427b1.jpg";